


import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;


    .box{
        width: 22px;
        height: 22px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};

        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: 1.2rem;
            color:#000;
        }

    }

    .label{
        font-size: 12px;
        font-weight: var(--font-weight-xl);
    }
`

const AliciSmsDogrulamaCheckbox = ({item, data, setData, keyData, labelText, addLoad}) => {
    const dispatch = useDispatch()

    const handleChange = (value) => {

        const updatedList = data.map((routeItem) => {
            if(routeItem.id === item.id){
                if(addLoad){
                    dispatch(updateRouteItem({id: item.id, smsVerification: value}))
                }
                
                return {...item, [keyData]: value}
            }
            else{
                return routeItem
            }
        })
        setData(updatedList)
    }

  return (
    <Container>
        <div className="box" onClick={() => handleChange(!item.smsVerification)}>{item.smsVerification && <GoCheck className="check-icon"/>}</div>
        <div className="label">{labelText}</div>
    </Container>
  )
}

export default AliciSmsDogrulamaCheckbox